module.exports = __webpack_public_path__ + "static/media/background_FRE.9128d0e8.jpg";